import ApiUtil from '@/api/api.util'
import ApiConfig from '@/api/api.config'
import EtnersCommonUtil from '../../common/etners.common.util'

const platformDomain = ApiConfig.platformDomain
const gewDomain = ApiConfig.gewDomain

const codeRequestStoreModule = {
  state    : {
    dataSource: {
      lastRequestParameters: {},
    },
    search    : {
      button: {
        specialDescription: {
          type : 'radio',
          data : [],
          index: 0,
        },
        additionalService : {
          type : 'radio',
          data : [],
          index: 0,
        },
        useYn             : { // 사용여부
          type : 'radio',
          data : [],
          index: 0,
        }
      },
      input : {
        requestNo: {
          type     : 'textbox',
          data     : '',
          validator: '',
        },
        patNm    : {
          type     : 'textbox',
          data     : '',
          validator: '',
        },
        telNo    : {
          type     : 'textbox',
          data     : '',
          validator: '',
        },
        email    : {
          type     : 'textbox',
          data     : '',
          validator: '',
        }
      },

      datepicker         : {

      },
      timepicker         : {

      },
      combobox           : {
        lockRsn       : { //100 계정잠금 사유
          type : 'combobox',
          data : [],
          index: 0,
        },
        loginGbn        : { // 101  접속 유형
          type : 'combobox',
          data : [],
          index: 0,
        },
        wmGbn            : { // 102  WEB/MOBILE 구분
          type : 'combobox',
          data : [],
          index: 0,
        },
        userBizType   : {// 103  사용자 타입(B2B/B2C)
          type : 'combobox',
          data : [],
          index: 0,
        },
        cmpyGbn            : { // 104  회사구분
          type : 'combobox',
          data : [],
          index: 0,
        },
        bizType               : { // 105  회사업종
          type : 'combobox',
          data : [],
          index: 0,
        },
        solGrup            : { // 106  솔루션그룹
          type : 'combobox',
          data : [],
          index: 0,
        },
        vdGbn            : { // 107  VENDOR구분
          type : 'combobox',
          data : [],
          index: 0,
        },
        boardType               : { // 108  게시판 유형
          type : 'combobox',
          data : [],
          index: 0,
        },
        categoryType               : { // 109  게시판별 카테고리 유형(108번과 연계)
          type : 'combobox',
          data : [],
          index: 0,
        },
        userGbn : { // 110  사용자 구분 유형
          type : 'combobox',
          data : [],
          index: 0,
        },
        central     : { // 200  본부
          type : 'combobox',
          data : [],
          index: 0,
        },
        teamGbn    : { // 201  팀구분
          type : 'combobox',
          data : [],
          index: 0,
        },
        psnScn               : { // 202  직위(직급)
          type : 'combobox',
          data : [],
          index: 0,
        },
        dutyScn           : { // 203  직책
          type : 'combobox',
          data : [],
          index: 0,
        },
        jobScn       : { // 204  직무
          type : 'combobox',
          data : [],
          index: 0,
        },
        genScn: { // 205  성별
          type : 'combobox',
          data : [],
          index: 0,
        },
        workScn         : { // 206  재직구분

          type : 'combobox',
          data : [],
          index: 0,
        },
        msgGbn             : { // 208  메시지 구분
          type : 'combobox',
          data : [],
          index: 0,
        },
        brdGbn              : { // 209  게시판구분
          type : 'combobox',
          data : [],
          index: 0,
        },
        impLevel            : { // 210  중요도
          type : 'combobox',
          data : [],
          index: 0,
        },
        priority          : { // 211  우선순위
          type : 'combobox',
          data : [],
          index: 0,
        },
        scrLevel    : { // 212  보안등급
          type : 'combobox',
          data : [],
          index: 0,
        },
        tdGbn                : { // 213  To-Do 유형
          type : 'combobox',
          data : [],
          index: 0,
        },
        todoStatus          : { // 214  To-Do 진행상태
          type : 'combobox',
          data : [],
          index: 0,
        },
        todoDtlStatus          : { //  215  To-Do 상세 진행상태
          type : 'combobox',
          data : [],
          index: 0,
        },
        fmyGbn          : { //  216  관계구분
          type : 'combobox',
          data : [],
          index: 0,
        }


      }
    }
  },
  getters  : {},
  mutations: {
    setUseYnData (state, data) {
      state.search.button.useYn.data = data
    },
    setLockRsnData (state, data) {
      state.search.combobox.lockRsn.data = data
    },
    setLockRsnIndex (state, index) {
      state.search.combobox.lockRsn.index = index
    },
    setLoginGbnData (state, data) {
      state.search.combobox.loginGbn.data = data
    },
    setLoginGbnIndex (state, index) {
      state.search.combobox.loginGbn.index = index
    },
    setWmGbnData (state, data) {
      state.search.combobox.wmGbn.data = data
    },
    setWmGbnIndex (state, index) {
      state.search.combobox.wmGbn.index = index
    },
    setUserBizTypeData (state, data) {
      state.search.combobox.userBizType.data = data
    },
    setUserBizTypeIndex (state, index) {
      state.search.combobox.userBizType.index = index
    },
    setCmpyGbnData (state, data) {
      state.search.combobox.cmpyGbn.data = data
    },
    setCmpyGbnIndex (state, index) {
      state.search.combobox.cmpyGbn.index = index
    },
    setBizTypeData (state, data) {
      state.search.combobox.bizType.data = data
    },
    setBizTypeIndex (state, index) {
      state.search.combobox.bizType.index = index
    },
    setSolGrupData (state, data) {
      state.search.combobox.solGrup.data = data
    },
    setSolGrupIndex (state, index) {
      state.search.combobox.solGrup.index = index
    },
    setVdGbnData (state, data) {
      state.search.combobox.vdGbn.data = data
    },
    setVdGbnIndex (state, index) {
      state.search.combobox.vdGbn.index = index
    },
    setBoardTypeData (state, data) {
      state.search.combobox.boardType.data = data
    },
    setBoardTypeIndex (state, index) {
      state.search.combobox.boardType.index = index
    },
    setCategoryTypeData (state, data) {
      state.search.combobox.categoryType.data = data
    },
    setCategoryTypeIndex (state, index) {
      state.search.combobox.categoryType.index = index
    },
    setUserGbnData (state, data) {
      state.search.combobox.userGbn.data = data
    },
    setUserGbnIndex (state, index) {
      state.search.combobox.userGbn.index = index
    },
    setCentralData (state, data) {
      state.search.combobox.central.data = data
    },
    setCentralIndex (state, index) {
      state.search.combobox.central.index = index
    },
    setTeamGbnData (state, data) {
      state.search.combobox.teamGbn.data = data
    },
    setTeamGbnIndex (state, index) {
      state.search.combobox.teamGbn.index = index
    },
    setPsnScnData (state, data) {
      state.search.combobox.psnScn.data = data
    },
    setPsnScnIndex (state, index) {
      state.search.combobox.psnScn.index = index
    },
    setDutyScnData (state, data) {
      state.search.combobox.dutyScn.data = data
    },
    setDutyScnIndex (state, index) {
      state.search.combobox.dutyScn.index = index
    },
    setJobScnData (state, data) {
      state.search.combobox.jobScn.data = data
    },
    setJobScnIndex (state, index) {
      state.search.combobox.jobScn.index = index
    },
    setGenScnData (state, data) {
      state.search.combobox.genScn.data = data
    },
    setGenScnIndex (state, index) {
      state.search.combobox.genScn.index = index
    },
    setWorkScnData (state, data) {
      state.search.combobox.workScn.data = data
    },
    setWorkScnIndex (state, index) {
      state.search.combobox.workScn.index = index
    },

    setMsgGbnData (state, data) {
      state.search.combobox.msgGbn.data = data
    },
    setMsgGbnIndex (state, index) {
      state.search.combobox.msgGbn.index = index
    },
    setBrdGbnData (state, data) {
      state.search.combobox.brdGbn.data = data
    },
    setBrdGbnIndex (state, index) {
      state.search.combobox.brdGbn.index = index
    },
    setImpLevelData (state, data) {
      state.search.combobox.impLevel.data = data
    },
    setImpLevelIndex (state, index) {
      state.search.combobox.impLevel.index = index
    },
    setPriorityData (state, data) {
      state.search.combobox.priority.data = data
    },
    setPriorityIndex (state, index) {
      state.search.combobox.priority.index = index
    },
    setScrLevelData (state, data) {
      state.search.combobox.scrLevel.data = data
    },
    setScrLevelIndex (state, index) {
      state.search.combobox.scrLevel.index = index
    },
    setTdGbnData (state, data) {
      state.search.combobox.tdGbn.data = data
    },
    setTdGbnIndex (state, index) {
      state.search.combobox.tdGbn.index = index
    },

    setTodoStatusData (state, data) {
      state.search.combobox.todoStatus.data = data
    },
    setTodoStatusIndex (state, index) {
      state.search.combobox.todoStatus.index = index
    },
    setTodoDtlStatusData (state, data) {
      state.search.combobox.todoStatus.data = data
    },
    setTodoDtlStatusIndex (state, index) {
      state.search.combobox.todoDtlStatus.index = index
    },
    setFmyGbnData (state, data) {
      state.search.combobox.fmyGbn.data = data
    },
    setFmyGbnIndex (state, index) {
      state.search.combobox.fmyGbn.index = index
    }
  },
  actions  : {

    /**********************************************************************
     * [주의사항]
     * actions 안에 정의하는 함수는 모듈별로 네임스페이스를 구분하지 않으므로,
     * 다른 모듈에서 사용하는 이름을 중복으로 사용하지 않아야 합니다.
     *
     * vue 모듈 안의 함수에서는 다음과 같이 호출이 가능합니다.
     *
     * this.$store.dispatch('initSearchDataForCodeRequest')
     *********************************************************************/

    /**
     * 페이지 로딩시 최초로 검색창 세팅.
     * 데이터를 ajax로 가져와서 세팅해야합니다.
     */
    initSearchDataForCodeRequest (context) {

      /** 여러개의 공통 코드를 동시에 요청할 경우에 대한 파라미터값 */
      const url = `${ApiConfig.platformDomain}/v1/ebmp/code/adminCommonCodes.json`
      const data = {
            "cmpyCd": "00000",
            "exceptCommonCodes":["217","218","219","220"]
      }

      const sessionUserData = JSON.parse(sessionStorage.loginUserData)
      ApiUtil.post(url, data).then(response => {
        const codeMap = response.data

/**
 *
 *
 * 100 계정잠금 사유 lockRsn
 101  접속 유형 loginGbn
 102  WEB/MOBILE 구분  wmGbn
 103  사용자 타입(B2B/B2C) userBizType
 104  회사구분 cmpyGbn
 105  회사업종 bizType
 106  솔루션그룹 solGrup
 107  VENDOR구분 vdGbn
 108  게시판 유형 boardType
 109  게시판별 카테고리 유형(108번과 연계) categoryType
 200  본부 central
 201  팀구분 teamGbn
 202  직위(직급) psnScn
 203  직책 dutyScn
 204  직무 jobScn
 205  성별 genScn
 206  재직구분 workScn
 208  메시지 구분 msgGbn
 209  게시판구분 brdGbn
 210  중요도 impLevel
 211  우선순위 priority
 212  보안등급 scrLevel
 213  To-Do 유형 tdGbn
 214  To-Do 진행상태 todoStatus
 215  To-Do 상세 진행상태 todoDtlStatus
 216  관계구분 fmyGbn
 *
 *
 *
 * */

        // 사용여부
        let useYnCodeMap = [
          { cdNm: "전체", cdNameSpace: "" },
          { cdNm: "사용", cdNameSpace: "Y" },
          { cdNm: "미사용", cdNameSpace: "N" }
        ]
        context.commit('setUseYnData', useYnCodeMap)


        context.commit('setLockRsnData', codeMap['100'])

        for (let i = 0; i < codeMap['100'].length; i++) {
          const code = codeMap['100'][i]

          if (code.selected === true) {
            context.commit('setLockRsnIndex', i)
          }
        }

        context.commit('setLoginGbnData', codeMap['101'])

        for (let i = 0; i < codeMap['101'].length; i++) {
          const code = codeMap['101'][i]

          if (code.selected === true) {
            context.commit('setLoginGbnIndex', i)
          }
        }
        context.commit('setWmGbnData', codeMap['102'])

        for (let i = 0; i < codeMap['102'].length; i++) {
          const code = codeMap['102'][i]

          if (code.selected === true) {
            context.commit('setWmGbnIndex', i)
          }
        }
        context.commit('setCmpyGbnData', codeMap['104'])

        for (let i = 0; i < codeMap['104'].length; i++) {
          const code = codeMap['104'][i]

          if (code.selected === true) {
            context.commit('setCmpyGbnIndex', i)
          }
        }
        context.commit('setUserBizTypeData', codeMap['103'])

        for (let i = 0; i < codeMap['103'].length; i++) {
          const code = codeMap['103'][i]

          if (code.selected === true) {
            context.commit('setUserBizTypeIndex', i)
          }
        }
        context.commit('setBizTypeData', codeMap['105'])

        for (let i = 0; i < codeMap['105'].length; i++) {
          const code = codeMap['105'][i]

          if (code.selected === true) {
            context.commit('setBizTypeIndex', i)
          }
        }
        context.commit('setSolGrupData', codeMap['106'])

        for (let i = 0; i < codeMap['106'].length; i++) {
          const code = codeMap['106'][i]

          if (code.selected === true) {
            context.commit('setSolGrupIndex', i)
          }
        }
        context.commit('setVdGbnData', codeMap['107'])

        for (let i = 0; i < codeMap['107'].length; i++) {
          const code = codeMap['107'][i]

          if (code.selected === true) {
            context.commit('setVdGbnIndex', i)
          }
        }
        context.commit('setBoardTypeData', codeMap['108'])

        for (let i = 0; i < codeMap['108'].length; i++) {
          const code = codeMap['108'][i]

          if (code.selected === true) {
            context.commit('setBoardTypeIndex', i)
          }
        }
        context.commit('setCategoryTypeData', codeMap['109'])

        for (let i = 0; i < codeMap['109'].length; i++) {
          const code = codeMap['109'][i]

          if (code.selected === true) {
            context.commit('setCategoryTypeIndex', i)
          }
        }

        context.commit('setUserGbnData', codeMap['110'])

        for (let i = 0; i < codeMap['110'].length; i++) {
          const code = codeMap['110'][i]

          if (code.selected === true) {
            context.commit('setUserGbnIndex', i)
          }
        }

        context.commit('setCentralData', codeMap['200'])

        for (let i = 0; i < codeMap['200'].length; i++) {
          const code = codeMap['200'][i]

          if (code.selected === true) {
            context.commit('setCentralIndex', i)
          }
        }
        context.commit('setTeamGbnData', codeMap['201'])

        for (let i = 0; i < codeMap['201'].length; i++) {
          const code = codeMap['201'][i]

          if (code.selected === true) {
            context.commit('setTeamGbnIndex', i)
          }
        }

        context.commit('setPsnScnData', codeMap['202'])

        for (let i = 0; i < codeMap['202'].length; i++) {
          const code = codeMap['202'][i]

          if (code.selected === true) {
            context.commit('setPsnScnIndex', i)
          }
        }
        context.commit('setDutyScnData', codeMap['203'])

        for (let i = 0; i < codeMap['203'].length; i++) {
          const code = codeMap['203'][i]

          if (code.selected === true) {
            context.commit('setDutyScnIndex', i)
          }
        }
        context.commit('setJobScnData', codeMap['204'])

        for (let i = 0; i < codeMap['204'].length; i++) {
          const code = codeMap['204'][i]

          if (code.selected === true) {
            context.commit('setJobScnIndex', i)
          }
        }
        context.commit('setGenScnData', codeMap['205'])

        for (let i = 0; i < codeMap['205'].length; i++) {
          const code = codeMap['205'][i]

          if (code.selected === true) {
            context.commit('setGenScnIndex', i)
          }
        }
        context.commit('setWorkScnData', codeMap['206'])

        for (let i = 0; i < codeMap['206'].length; i++) {
          const code = codeMap['206'][i]

          if (code.selected === true) {
            context.commit('setWorkScnIndex', i)
          }
        }

        context.commit('setMsgGbnData', codeMap['208'])

        for (let i = 0; i < codeMap['208'].length; i++) {
          const code = codeMap['208'][i]

          if (code.selected === true) {
            context.commit('setMsgGbnIndex', i)
          }
        }
        context.commit('setBrdGbnData', codeMap['209'])

        for (let i = 0; i < codeMap['209'].length; i++) {
          const code = codeMap['209'][i]

          if (code.selected === true) {
            context.commit('setBrdGbnIndex', i)
          }
        }
        context.commit('setImpLevelData', codeMap['210'])

        for (let i = 0; i < codeMap['210'].length; i++) {
          const code = codeMap['210'][i]

          if (code.selected === true) {
            context.commit('setImpLevelIndex', i)
          }
        }
        context.commit('setPriorityData', codeMap['211'])

        for (let i = 0; i < codeMap['211'].length; i++) {
          const code = codeMap['211'][i]

          if (code.selected === true) {
            context.commit('setPriorityIndex', i)
          }
        }

        context.commit('setScrLevelData', codeMap['212'])

        for (let i = 0; i < codeMap['212'].length; i++) {
          const code = codeMap['212'][i]

          if (code.selected === true) {
            context.commit('setScrLevelIndex', i)
          }
        }
        context.commit('setTdGbnData', codeMap['213'])

        for (let i = 0; i < codeMap['213'].length; i++) {
          const code = codeMap['213'][i]

          if (code.selected === true) {
            context.commit('setTdGbnIndex', i)
          }
        }
        context.commit('setTodoStatusData', codeMap['214'])

        for (let i = 0; i < codeMap['214'].length; i++) {
          const code = codeMap['214'][i]

          if (code.selected === true) {
            context.commit('setTodoStatusIndex', i)
          }
        }
        context.commit('setTodoDtlStatusData', codeMap['215'])

        for (let i = 0; i < codeMap['215'].length; i++) {
          const code = codeMap['215'][i]

          if (code.selected === true) {
            context.commit('setTodoDtlStatusIndex', i)
          }
        }

        context.commit('setFmyGbnData', codeMap['216'])

        for (let i = 0; i < codeMap['216'].length; i++) {
          const code = codeMap['216'][i]

          if (code.selected === true) {
            context.commit('setFmyGbnIndex', i)
          }
        }



      })

    },

  },
}

export default codeRequestStoreModule
